export default __webpack_public_path__ + "static/media/ic-star-add.669710c0.svg";